<style lang="scss">
 @import '../style/style.scss';
    .el-pagination{
        li,button{
            border: 1px solid #CACACA !important;
            background-color: #fff !important;
        }
        .active{
            border:none !important;
            background: #3895FE !important;
        }
    }
</style>
<template>
    <el-pagination
    @current-change="getData"
    background :page-size='page_size?page_size:20'
    @size-change="handleSizeChange"
    :current-page="current"
    :page-sizes="[10,20, 30, 40, 50,60,70,80,90,100]"
    layout="total,sizes,prev, pager, next"
    :total="total">
    </el-pagination>
</template>
<script>
export default {
    data(){
        return{
            page:1
        }
    },
    props: {
        total:'',
        page_size:'',
        current:''
    },
    methods:{
        getData(type){
            // if(type == 1){
            //     this.data.pageNumber=this.data.pageNumber-1
            // }else if(type == 2){
            //     this.data.pageNumber=this.data.pageNumber+1
            // }
             this.page=type
            this.$emit('pageChange')
        },
        handleSizeChange(val){
            this.$emit('pageChange',val)
        }
    },
    created(){
    }
}
</script>